import React from 'react';
import WarningMsg from "../../../shared/ui/warningMsg/WarningMsg";

const MessageCalendar = ({savedWeek = false, isUpdate, isSalvageable}: {
    savedWeek?: boolean
    isUpdate: boolean
    isSalvageable: boolean
}) => {
    const msgBlocked: any = {
        savedWeek: 'La settimana è salvata correttamente',
        savedWeekUpdate: 'La settimana è salvata ma la versione attuale è modificata, congela prospetto per normalizzare i dati',
        savedWeekUpdateNoSave: 'La settimana è salvata ma la versione attuale è modificata, non puoi congelare i dati perchè sono errati, sistemali per salvarli',
        noSave: 'Non puoi congelare i dati perchè sono errati, sistemali per salvare la settimana',
        //['false-true']: `Non puoi modificare questa settimana perché è già stata salvata. Tutte le azioni sono bloccate.`,
        //['false-false']: `Non puoi salvare questa settimana perché non è la settimana successiva all’ultimo salvataggio (${dateFormatGGmmmYYYY(blockedState?.lastWeek?.dateStart)} - ${dateFormatGGmmmYYYY(blockedState?.lastWeek?.dateEnd)}). Puoi comunque modificare le ore sul calendario.`,
    };
    let msg = ''
    if(savedWeek){
        msg= msgBlocked.savedWeek
        if(isUpdate){
            msg= msgBlocked.savedWeekUpdate
            if(!isSalvageable){
                msg= msgBlocked.savedWeekUpdateNoSave
            }
        }
    } else {
        if(!isSalvageable){
            msg= msgBlocked.noSave
        }
    }

    return (
        <>
            {msg && <WarningMsg
                msg={msg}/>}
        </>

    );
};

export default MessageCalendar;
